export default {
  "Sivut": "Puslapiai",
  "Ei luokiteltu": "Nekategorizuota",
  "Viimeiset 8 viikkoa": "Paskutinės 8 savaitės",
  "Vie palautteet": "Eksportuoti atsiliepimus",
  "Ulkoasuasetukset": "Išvaizdos nustatymai",
  "Logo": "Logotipas",
  "Väri": "Spalva",
  "Logon tulee olla PNG-tiedosto, jonka tausta on läpinäkyvä.": "Logotipas turi būti PNG failas su skaidriu fonu.",
  "Ei logoa": "Nėra logotipo",
  "Valitse logo": "Pasirinkti logotipą",
  "Logon tulee olla PNG-tiedosto.": "Logotipas turi būti PNG failas.",
  "Tiedosto on liian suuri (max 5 MB).": "Failas per didelis (maks. 5 MB).",
  "Logon tausta tulee olla läpinäkyvä.": "Logotipo fonas turi būti skaidrus.",
  "Tiedostoa ei voitu lukea kuvana.": "Failo nepavyko nuskaityti kaip vaizdo.",
  "Logon tallennus epäonnistui.": "Nepavyko išsaugoti logotipo.",
  "Poista logo": "Pašalinti logotipą",
  "Logon poistaminen epäonnistui.": "Nepavyko pašalinti logotipo.",
  "Näytön logo korvaa yrityksen logon tällä näytöllä. Kuvan ei tarvitse olla neliö.": "Ekrano logotipas pakeičia įmonės logotipą šiame ekrane. Vaizdas neprivalo būti kvadratinis.",
  "Tehosteväriä käytetään sovelluksen painikkeissa, otsikoissa ja korostuksissa.": "Pagrindinė spalva naudojama programos mygtukams, antraštėms ir paryškinimams.",
  "Esikatselu": "Peržiūra",
  "Esimerkki": "Pavyzdys",
  "Painike": "Mygtukas",
  "Värin tallennus epäonnistui.": "Nepavyko išsaugoti spalvos.",
  "Pääkäyttäjät": "Pagrindiniai naudotojai",
  "Vain pääkäyttäjät voivat lisätä tai poistaa toisia pääkäyttäjiä.": "Tik pagrindiniai naudotojai gali pridėti ar pašalinti kitus pagrindinius naudotojus.",
  "Näytä loki": "Rodyti žurnalą",
  "Lisää pääkäyttäjä": "Pridėti pagrindinį naudotoją",
  "Ei pääkäyttäjiä": "Nėra pagrindinių naudotojų",
  "Et voi poistaa itseäsi pääkäyttäjistä": "Negalite pašalinti savęs iš pagrindinių naudotojų",
  "Viimeistä pääkäyttäjää ei voi poistaa": "Paskutinio pagrindinio naudotojo pašalinti negalima",
  "Poista pääkäyttäjistä": "Pašalinti iš pagrindinių naudotojų",
  confirm_remove_mainuser: "Ar tikrai norite pašalinti naudotoją {name} iš pagrindinių naudotojų? Naudotojas liks sistemoje kaip įprastas naudotojas.",
  "Hae käyttäjää": "Ieškoti naudotojo",
  "Kirjoita nimi tai sähköposti": "Įveskite vardą arba el. paštą",
  "Ei tuloksia": "Rezultatų nėra",
  "Lisää pääkäyttäjäksi": "Pridėti kaip pagrindinį naudotoją",
  "Pääkäyttäjän lisääminen epäonnistui": "Nepavyko pridėti pagrindinio naudotojo",
  "Pääkäyttäjien muutosloki": "Pagrindinių naudotojų pakeitimų žurnalas",
  "Ei merkintöjä": "Įrašų nėra",
  "Toiminto": "Veiksmas",
  "Suoritti": "Atliko",
  "Pääkäyttäjän oikeudet lisätty": "Pagrindinio naudotojo teisės suteiktos",
  "Pääkäyttäjän oikeudet poistettu": "Pagrindinio naudotojo teisės pašalintos",

  "feedback_newview_info": "Atnaujiname atsiliepimų valdymą! Išbandykite naują vaizdą žemiau. Nauja sąsaja taps numatytąja ateityje.",
  "Uusi näkymä": "Naujas vaizdas",
  "Ohjeet": "Instrukcijos",
  "Puhelinnumero": "Telefono numeris",
  "Pitkä vastaus": "Ilgas atsakymas",
  "Lyhyt vastaus": "Trumpas atsakymas",
  "Valitse yksi": "Pasirinkite vieną",
  "Takaisin": "Atgal",
  "Saapuneet / luokka": "Gauta / kategorija",
  "Vanha näkymä": "Senas vaizdas",
  "Päivitä": "Atnaujinti",
  "Näytä valmiit": "Rodyti užbaigtus",
  "Tieto ei näy palautteen lähettäjälle": "Informacija nematoma atsiliepimo siuntėjui",
  "Sisäinen otsikko": "Vidinis pavadinimas",
  "Ei valmiita palautteita": "Nėra užbaigtų atsiliepimų",
  "Ei saapuneita palautteita": "Nėra gaunamų atsiliepimų",
  "Ei käsittelyssä olevia palautteita": "Nėra apdorojamų atsiliepimų",
  "Näytä infotv näytöillä": "Rodyti Infotv ekranuose",
  "Lomake": "Forma",
  "Ei käytössä": "Nenaudojama",
  "Käytä mukautettua lomaketta": "Naudoti pasirinktinę formą",
  "Poista palautetyyppi käytöstä ja tallenna muutokset muokataksesi lomakekenttiä": "Išjunkite atsiliepimo tipą ir išsaugokite pakeitimus, kad galėtumėte redaguoti formos laukus",
  "Sisältö": "Turinys",
  "Asetukset": "Nustatymai",
  "Lataa ja lisää": "Įkelti ir pridėti",
  "Näyttö": "Ekranas",
  "Toissijainen sisältö (30%)": "Antrinis turinys (30%)",
  "Pääsisältö (70%)": "Pagrindinis turinys (70%)",
  "Alatunnisteen tekstit": "Poraštės tekstai",
  "Lisää teksti": "Pridėti tekstą",
  "Näytöt": "Ekranai",
  "Ulkoasu": "Išvaizda",
  "Sää": "Orai",
  "Näytön sisällönhallinta": "Ekrano turinio valdymas",
  "Asettelu": "Išdėstymas",
  "Haluatko varmasti poistaa sisällön näytöltä?": "Ar tikrai norite pašalinti turinį iš ekrano?",
  "Jaettu asettelu (70% / 30%)": "Padalintas išdėstymas (70% / 30%)",
  "Koko leveys": "Visas plotis",
  "Tumma tila": "Tamsus režimas",
  "Näytä alatunniste": "Rodyti poraštę",
  "Sisällön näyttöaika (sekuntia)": "Turinio rodymo laikas (sekundėmis)",
  "Valitse kirjastosta": "Pasirinkti iš bibliotekos",
  "Ei hakutuloksia": "Paieškos rezultatų nėra",
  "Ei kuvia kirjastossa": "Bibliotekoje nėra vaizdų",
  "Lisää näytölle": "Pridėti į ekraną",
  "Virhe lisättäessä sisältöä": "Klaida pridedant turinį",
  "kohdetta": "elementai",
  "Lisää": "Pridėti",
  "Lataa kuva": "Įkelti paveikslėlį",
  "Kirjastosta": "Iš bibliotekos",
  "Uutiset": "Naujienos",
  "Tapahtumat": "Renginiai",
  "Lisää sisältöä yllä olevilla painikkeilla": "Pridėkite turinį naudodami aukščiau esančius mygtukus",
  "aktiivista uutista.": "aktyvios naujienos.",
  "Näytetään max 5 uusinta uutista": "Rodoma ne daugiau kaip 5 naujausios naujienos",
  "Ei aktiivisia uutisia": "Nėra aktyvių naujienų",
  "Ilmoittautuneet": "Registruoti",
  "permanent_pages_info": "Nuolatiniai puslapiai Piiri programėlės meniu rodomi kaip atskiros skiltys (pavyzdžiui, su antrašte Mūsų įmonė). Galite kurti naujas skiltis, jei norite nuolatinių puslapių turinį suskirstyti į atskiras temas, matomas meniu. Nauja skiltis meniu bus rodoma iš naujo paleidus programėlę arba atnaujinus naršyklės puslapį",
  "Osio": "Skiltis",
  "Luo uusi osio": "Sukurti naują skiltį",
  "Pysyvät sivut": "Nuolatiniai puslapiai",
  "Uusi kyselytyökalu": "Naujas apklausos įrankis",
  "Lomakkeella on vastauksia. Muokkaus rajoitettu.": "Formoje yra atsakymų. Redagavimas ribotas.",
  "Huom: Lomaketta voi muokata rajoitetusti sen jälkeen kun siihen on tullut vastauksia.": "Pastaba: Forma gali būti redaguojama tik ribotai po to, kai yra gauta atsakymų.",
  "surveyinfo1": "Atnaujiname apklausas. Galite išbandyti naują apklausos įrankį",
  "surveyinfo2": "Piiri mobilioji programėlė turi būti atnaujinta į naują versiją (1.15.0), kad nauju apklausų įrankiu sukurtos apklausos būtų matomos vartotojams.",
  "Sinulla ei ole oikeuksia kaikkiin tämän julkaisun ryhmiin.": "Jūs neturite teisių visoms šio leidinio grupėms.",
  "Voit tarkastella julkaisua, mutta et voi tehdä muutoksia.": "Galite peržiūrėti leidinį, bet negalite daryti pakeitimų.",
  "Oletus": "Prielaida",
  "Vie kaaviot kuvana": "Eksportuoti diagramas kaip vaizdą",
  "Suodattimet": "Filtrai",
  "Tyhjennä": "Išvalyti",
  "Aikavyöhyke": "Laiko juosta",
  "Vastausvaihtoehto": "Atsakymo parinktis",
  "Lisää vaihtoehto": "Pridėti parinktį",
  "Tyhjä vaihtoehto": "Tuščia parinktis",
  "Vaihtoehto": "Parinktys",
  "Vastausvaihtoehdot": "Atsakymo parinktys",
  "Haluatko varmasti poistaa vastausvaihtoehdon?": "Ar tikrai norite pašalinti atsakymo parinktį?",
  "vastausta": "atsakymų",
  "Ei vastauksia": "Nėra atsakymų",
  "Kentällä ei ole otsikkoa": "Laukas neturi pavadinimo",
  "Klikkaa muokataksesi kenttää": "Spustelėkite, kad redaguotumėte lauką",
  "Ohjeteksti (valinnainen)": "Pagalbinis tekstas (neprivaloma)",
  "Päivämäärä": "Data",
  "Pakollinen": "Privaloma",
  "Kentän otsikko": "Lauko pavadinimas",
  "Tietotyyppi": "Duomenų tipas",
  "Vastausaika on pakollinen": "Atsakymo laikas yra privalomas",
  "Monirivinen teksti": "Daugialypės eilutės tekstas",
  "Ei kysymyksiä. Lisää ensimmäinen kysymys vasemmalta.": "Nėra klausimų. Pridėti pirmąjį klausimą iš kairės.",
  "Monivalinta": "Daugkartinis pasirinkimas",
  "Valinta": "Pasirinkimas",
  "Valitse vähintään yksi ryhmä": "Pasirinkite bent vieną grupę",
  "Teksti": "Tekstas",
  "Lisää kysymys": "Pridėti klausimą",
  "Lomakkeen kentät": "Formos laukai",
  "Julkaise ryhmiin": "Skelbti grupėms",
  "Kopioi kysely": "Kopijuoti apklausą",

  "Tietoa Piiri-sovelluksesta": "Apie Piiri programėlę",
  "Vaadi lukukuittaus": "Reikalauti skaitymo patvirtinimo",
  "Selite (valinnainen)": "Aprašas (neprivaloma)",
  "Teksti näytetään käyttäjille lukukuittauksen yhteydessä": "Tekstas rodomas vartotojams, kai jie patvirtina skaitymą",
  "Jos nostatte versionumeroa, käyttäjiltä vaaditaan sisällölle uudelleen lukukuittaus": "Jei padidinsite versijos numerį, vartotojai turės dar kartą patvirtinti turinio skaitymą",
  "Sivu": "Puslapis",
  "Lukukuittaus saatu": "Gautas skaitymo patvirtinimas",
  "Ei lukukuittausta": "Nėra skaitymo patvirtinimo",
  "Lukukuittauksia ei ole käytössä": "Skaitymo patvirtinimai nėra įjungti",
  "Versio": "Versija",
  "Raportti": "Ataskaita",
  "Ryhmän ylläpitäjä näkee vain ylläpitämiensä ryhmien tiedostot": "Grupės administratorius gali matyti tik tų grupių failus, kurias jis valdo",
  "Muokkaa kansiota": "Redaguoti aplanką",
  "Uusi kansio": "Naujas aplankas",
  "Uusi alikansio": "Naujas poaplankis",
  "tiedostoa": "failai",
  "Muokkaa": "Redaguoti",
  "Lukukuittaukset": "Skaitymo patvirtinimai",
  "Failed to submit acknowledgment. Please try again.": "Nepavyko pateikti patvirtinimo. Bandykite dar kartą.",
  "Kuittaa luetuksi": "Pažymėti kaip perskaitytą",
  "Lukukuittaus": "Skaitymo patvirtinimas",
  "Lukukuittaus vaaditaan": "Reikalingas skaitymo patvirtinimas",
  "Olet kuitannut tämän luetuksi": "Jūs pažymėjote tai kaip perskaitytą",
  "Sisältö on päivittynyt viime kuittauksesi jälkeen. Kuittaa uudelleen.": "Turinys buvo atnaujintas po paskutinio jūsų patvirtinimo. Patvirtinkite dar kartą.",
  "Tämä sisältö vaatii lukukuittauksen.": "Šis turinys reikalauja skaitymo patvirtinimo.",
  "Your browser does not support the video tag.": "Jūsų naršyklė nepalaiko vaizdo žymos.",
  "Avaa linkki": "Atidaryti nuorodą",
  "Kaikki tiedostot": "Visi failai",
  "Kansio": "Aplankas",
  "Avaa tiedosto": "Atidaryti failą",
  "Kansion nimi": "Aplanko pavadinimas",
  "Järjestys": "Vartotojo sąsajos tvarka",
  "Haluatko varmasti poistaa kansion?": "Ar tikrai norite ištrinti aplanką?",
  "Anna kansion nimi": "Įveskite aplanko pavadinimą",
  "Vie ilmoittautumiset": "Eksportuoti registracijas",
  "Avainsanoilla voidaan luokitella ja suodattaa uutisia.": "Naujienas galima klasifikuoti ir filtruoti naudojant raktažodžius.",
  "Ryhmä on käytössä": "Grupė yra aktyvi",
  "Ryhmä ei ole käytössä": "Grupė nėra aktyvi",
  "DisableGroupInfo": "Grupė gali būti pažymėta kaip neaktyvi, jei ji neturi:\n- administratoriaus\n- diskusijų kanalo\n- Mūsų įmonės puslapio (arba kito pavadinto nuolatinio puslapio)\n\nTaip pažymėsite naudotą grupę kaip neaktyvią:\n- Pašalinkite grupės administravimo teises naudotojų valdyme.\n- Pažymėkite su grupe susietus diskusijų kanalus kaip neaktyvius.\n- Pašalinkite grupei sukurtus Mūsų įmonės puslapius arba perkelkite juos kitai grupei. Jei nuolatinis puslapis matomas kelioms grupėms, pakanka pašalinti jo matomumą iš šalinamos grupės.\n\nDėmesio!\nKitas grupei sukurtas turinys (naujienos, renginiai, apklausos, failai) išliks Piiryje net ir ištrynus grupę.",
  "Käyttäjä halitsee tietoa itse": "Vartotojas pats valdo informaciją",
  "Käyttäjän kielivalinta": "Vartotojo kalbos pasirinkimas",
  "Tiedoston maksimikoko on 10MB": "Maksimalus failo dydis yra 10 MB",
  "Peruuta": "Atšaukti",
  "Avainsanat käytössä": "Naudojami raktiniai žodžiai",
  "Uusi ryhmä": "Nauja grupė",
  "Ryhmän nimi": "Grupės pavadinimas",
  "Hae": "Gauti iš",
  "Järjestä": "Rūšiuoti pagal",
  "department-info": "Padalinių naudojimas yra savanoriškas. Darbuotojų suskirstymas į padalinius matomas tik skiltyje „Pas mus darbe“. Jei įmonė suskirsto darbuotojus į padalinius, vartotojai gali ieškoti kontaktinės informacijos pagal padalinį.",
  "Oletusuutiskuva": "Numatytoji naujienų nuotrauka",
  "Julkaisuasetukset": "Publikavimo nustatymai",
  "Oletusuutiskuvaa käytetään logon sijaan uutisissa mikäli uutisella ei ole omaa kuvaa.": "Jei naujienos neturi savo paveikslėlio, vietoj logotipo naudojamas numatytasis naujienos paveikslėlis.",
  "Hae otsikolla": "Ieškoti pagal pavadinimą",
  "Kysymys julkaistaan heti": "Klausimas bus paskelbtas nedelsiant",
  "Tapahtuma julkaistaan julkaisuaikana": "Renginys bus paskelbtas paskelbimo metu",
  "Nimi on pakollinen kaikilla kielillä": "Vardas yra privalomas visomis kalbomis",
  "Uusi osasto": "Naujas skyrius",
  "Kaikki": "Visi",
  "Osastot": "Skyriai",
  "Oma tila": "Mano statusas",
  "Yhteiset liitteet": "Bendrieji priedai",
  "attachment_lang_tip": "Bendrieji priedai matomi visiems, nepriklausomai nuo pasirinktos kalbos. Kalbos versijos priedai matomi tik tos kalbos naudotojams.",
  "Käännös suoritettu. Varmista käännöksen oikeellisuus ennen tallentamista.": "Vertimas baigtas. Prieš išsaugodami patikrinkite vertimo tikslumą.",
  "Suorita käännös": "Atlikti vertimą",
  "Automaattinen käännös": "Automatinis vertimas",
  "deepl_notice": "Turiniui versti naudojama <a href='https://www.deepl.com/en/translator' target='_blank'> DeepL paslauga</a>. Atkreipkite dėmesį, kad išverstas tekstas bus siunčiamas apdoroti į „DeepLi“ serverius. Įmonė atsako už išversto turinio tikslumą ir tinkamumą. Šis įrankis skirtas tik Piiri turiniui versti.",
  "Haluatko varmasti poistaa käyttäjän? Toimintoa ei voi perua!": "Ar tikrai norite ištrinti naudotoją? Veiksmų atšaukti negalima!",
  "Jos haluat päivittää kuvan, poista ensin olemassa oleva kuva": "Jei norite atnaujinti vaizdą, pirmiausia pašalinkite esamą vaizdą.",
  "Push-ilmoitukset käytössä": "Siųsti pranešimus",
  "ryhmää": "grupę",
  "Kansikuvat": "Viršelio nuotraukos",
  "Ei kuvia, näytetään logo": "Nėra nuotraukų, rodomas logotipas",
  "Lisää uusi kansikuva": "Pridėti naują viršelio nuotrauką",
  "Enintään 5 kuvaa voidaan lisätä": "Galima pridėti ne daugiau kaip 5 nuotraukas",
  "Haluatko varmasti poistaa kuvan?": "Ar tikrai norite ištrinti nuotrauką?",
  "Kuvien suositeltu kuvasuhde on 16:9, esim. 1920x1080px": "Rekomenduojamas nuotraukų formato santykis yra 16:9, pvz., 1920x1080px",
  "Kuvat näytetään kuvakarusellissa": "Nuotraukos rodomos karuselėje",
  "Vastauksiin liitetään nimi automaattisesti": "Atsakymams automatiškai pridedamas vardas",
  "Kyselyyn voi vastata useita kertoja": "Apklausai galima atsakyti kelis kartus",
  "Vastaukset kerätään anonyymisti": "Atsakymai surenkami anonimiškai",
  "Tätä asetusta ei voi muuttaa sen jälkeen kun kyselyyn on vastattu": "Šio nustatymo negalima keisti po atsakymo į apklausą",
  "Salli useita vastauksia samalta käyttäjältä": "Leisti kelis atsakymus iš to paties naudotojo",
  "Palautteiden käsittelijäksi voidaan...": "Pastaba: Atgalinių ryšių tvarkytoju gali būti pasirinktas pagrindinis vartotojas arba grupės administratorius. Galite pridėti grupės administratoriaus teises naudotojo nustatymuose skiltyje Naudotojai.",
  "Kaikki muutokset kirjataan lokiin": "Visi pakeitimai atsiliepimų tvarkytojams išsaugomi žurnale. (Norėdami peržiūrėti žurnalą, spustelėkite dešinėje esančią piktogramą.)",
  "Valitse käsittelyoikeudet": "Pasirinkite tvarkymo teises",
  "Käsittelyoikeudet": "Tvarkymo teisės",
  "Tallennus onnistui": "Išsaugoti pavyko",
  "Aikaleima": "Laiko žymė",
  "Suorittanut": "Vykdęs",
  "Kohdekäyttäjä": "Tikslinis naudotojas",
  "Tapahtuma": "",
  "Loki": "Žurnalas",
  "CategoryInfo": "Atsiliepimų klasifikavimas neaktyvuotas. Kurkite skirtingus atsiliepimų tipus ir priskirkite jiems kategorijas pasirinkdami \"Naujas atsiliepimo tipas\" ir parašydami nurodymus atsiliepimų tipui.",
  "Palautetyypit": "Atsiliepimų tipai",
  "Palautetyypin nimi": "Atsiliepimo tipo pavadinimas",
  "Valitse palautteen tyyppi": "Pasirinkite atsiliepimo tipą",
  "Otsikko on pakollinen kaikilla kielillä": "Antraštė privaloma visomis kalbomis",
  "Ohje palautteen lähettäjälle (esim. mitä tietoja ilmoitukseen tulee lisätä)": "Instrukcijos atsiliepimo teikėjui (pvz., kokią informaciją turi pridėti į pranešimą)",
  "Lyhyt kuvaus (milloin palautetyyppiä käytetään)": "Trumpas aprašymas (kada naudojamas atsiliepimo tipas)",
  "Uusi palautetyyppi": "Naujas atsiliepimo tipas",
  "Palautteiden luokittelu": "Atsiliepimų klasifikavimas",
  "Haluatko varmasti ottaa palautteen käsittelyyn?": "Ar tikrai norite imtis atsiliepimo tvarkymo?",
  "Käyttäjä on jättänyt yhteystiedot yhteydenottoa varten": "Naudotojas paliko kontaktin informaciją susisiekti",
  "Palaute on käsitelty": "Atsiliepimas apdorotas",
  "Palauteilmoitukset": "Atsiliepimų tvarkytojai",
  "Kirjoita viesti": "Parašykite žinutę",
  "Sinä": "Tu",
  "Voit lähettää yhden viestin vastauksena": "Galite siųsti vieną atsakymą kaip žinutę",
  "Haluatko varmasti lähettää viestin?": "Ar tikrai norite išsiųsti žinutę?",
  "Palautteet": "Atsiliepimai",
  "Näytä lähetetyt palautteet": "Rodyti išsiųstus atsiliepimus",
  "Piilota lähetetyt palautteet": "Slėpti išsiųstus atsiliepimus",
  "Haluatko jättää yhteystietosi henkilökohtaista vastausta varten?": "Ar norite palikti savo kontaktin informaciją asmeniniam atsakymui?",
  "Käsitelty": "Apdorota",
  "Avoin": "Atviras",
  "Voit lähettää palautteen lähettäjälle viestin tai vastauksen sen jälkeen, kun palaute on otettu käsittelyyn": "Galite išsiųsti žinutę ar atsakymą kurio siuntėjui po to, kai atsiliepimas paimtas tolesniam apdorojimui",
  "Tietoja": "Informacija",
  "Palautteen lähettäjä voi vastata lähettämääsi viestiin tai viesteihin niin kauan, kunnes palaute on merkitty käsitellyksi.": "Atsiliepimo teikėjui leidžiama atsakyti į jūsų siųstą žinutę ar žinutes tol, kol atsiliepimas nepažymėtas kaip apdorotas.",
  "Käyttäjä": "Vartotojas",
  "Yhteystiedot": "Kontaktai",
  "Viestit": "Žinutės",
  "Käyttäjä ei ole jättänyt yhteystietoja": "Vartotojas nepateikė kontaktinės informacijos",
  "Lähetä lisäkysymys tai vastus": "Siųsti papildomą klausimą arba atsakymą",
  "Vie vastaukset": "Eksportuoti atsakymus",
  "Päivitykset": "Atnaujinimai",
  "Kutsu uudet käyttäjät": "Pakviesti naujus vartotojus",
  "Lisää uusi palautteiden käsittelijä": "Pridėti naują atsiliepimų tvarkytoją",
  "Ilmoitus sähköpostiin": "Pranešimas el. paštu",
  "Push-viesti puhelimeen": "Push pranešimas į telefoną",
  "Kutsu käyttäjiä": "Pakviesti vartotojus",
  "Käytä viestipohjaa": "Naudoti žinutės šabloną",
  "Kutsuohje": "Žemiau esanti žinutė bus išsiųsta atrinktiems naudotojams kaip tekstinė žinutė. Prieš siųsdami galite redaguoti žinutę.",
  "Varmista, että käyttäjien puhelinnumerot ovat oikein ennen viestin lähetystä.": "Įsitikinkite, kad naudotojų telefono numeriai yra teisingi prieš siųsdami žinutę.",
  "Kutsumattomia käyttäjiä ei löytynyt": "Nepakviestų naudotojų nerasta",
  "Kutsu valitut käyttäjät": "Pakviesti atrinktus naudotojus",
  "Lähetys käynnissä, odota...": "Siuntimas vyksta, palaukite...",
  "Lähetys on valmis": "Siuntimas baigtas",
  "Kutsu käyttäjälle": "Pakvietimas naudotojui",
  "numeroon": "numeris",
  "epäonnistui": "nepavyko",
  "Päivitä lista": "Atnaujinti sąrašą",
  "Viesti on pakollinen": "Žinutė yra privaloma",
  "Kirjoita vastaus": "Įveskite atsakymą",
  "Vastauksia": "Atsakymai",
  "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomutooja ovat ": "Failo formatas nepalaikomas. Palaikomi formato tipai yra ",
  "Liitetiedosto": "Pridedamasis failas",
  "Halutessasi voi liittää liitetiedoston": "Jei norite, galite pridėti failą",
  "Halutessasi voit liittää mukaan kuvan tai pdf-tiedoston": "Norėdami galite pridėti paveikslėlį ar pdf failą",
  "Liite": "Priedas",
  "Ladataan...": "Įkeliama...",
  "Vastausaika on päättynyt": "Atsakymo laikas baigėsi",
  "Ei ilmoittautumisia": "Nėra užsiregistravusių",
  "Voit lähettää viestin Ctrl Enter painikkeilla": "Galite siųsti žinutę paspausdami Ctrl + Enter",
  "Omat keskustelut": "Mano pokalbiai",
  "Näytä keskustelukanavat": "Rodyti pokalbių kanalus",
  "Yksityinen kanava": "Privatus kanalas",
  "Hallinnoit tätä kanavaa": "Tvarkote šį kanalą",
  "Aloita uusi keskustelu": "Pradėti naują pokalbį",
  "Miten palautteet käsitellään": "Kaip tvarkomi atsiliepimai",
  "Palauteasetukset": "Atsiliepimų nustatymai",
  "Haku": "Paieška",
  "Omat tiedot ja asetukset": "Mano duomenys ir nustatymai",
  "Julkaisuaika on pakollinen": "Paskelbimo laikas yra privalomas",
  "Kuvaus...": "Aprašymas...",
  "Saapunut ...": "Atvyko ...",
  "Nimi puuttuu": "Trūksta vardo",
  "Haluatko varmasti poistaa tapahtuman?": "Ar tikrai norite ištrinti įvykį?",
  "Ylläpito": "Administravimas",
  "Etusivu": "Pagrindinis puslapis",
  "Hallinta": "Valdymas",
  "Muut": "Pridėti",
  "Omat tiedot": "Mano duomenys",
  "Kirjaudu ulos": "Atsijungti",
  "Lähetä": "Siųsti",
  "Olet vastannut kyselyyn": "Jūs atsakėte į apklausą",
  "Kyselyt": "Apklausos",
  "Vastausaika päättyy": "Atsakymo laikas baigiasi",
  "Ei kyselyjä": "Nėra apklausų",
  "Uusi tiedosto lisätty": "Naujas failas pridėtas",
  "Yritys": "Įmonė",
  "Raahaa kuva tähän tai klikkaa tästä ja valitse kuva tiedostoista.": "Vilkti paveikslėlį čia arba spustelėti čia ir pasirinkti paveikslėlį iš failų.",
  "Kuponki": "Kuponas",
  "Otsikko": "Antraštė",
  "Kuvaus": "Aprašymas",
  "Etu julkaistaan heti": "Nauda paskelbiama iškart",
  "Etu tallennetaan luonnoksena": "Nauda išsaugoma kaip projektas",
  "Julkaise": "Skelbti",
  "Tarkista lomakkeen tiedot": "Patikrinti formos duomenis",
  "Poista": "Pašalinti",
  "Tallenna": "Išsaugoti",
  "Tallenna lisätieto": "Išsaugoti papildomą informaciją",
  "Henkilöstöedut": "Personaliniai privalumai",
  "Uusi etu": "Nauja privilegija",
  "Julkaistu": "Paskelbta",
  "Keskustelukanavat": "Pokalbių kanalai",
  "Nimi": "Vardas",
  "Kuva": "Paveikslėlis",
  "Kanavan tyyppi": "Kanalų tipas",
  "Yksityinen keskustelu": "Privatus pokalbis",
  "Ryhmäkeskustelu": "Atviras grupės pokalbis",
  "Kanavaa hallinnoivat": "Kanalą valdo",
  "Käytössä": "Naudojama",
  "Kanava on käytössä": "Kanalas naudojamas",
  "Kanava ei ole käytössä": "Kanalas nenaudojamas",
  "Uusi kanava": "Naujas kanalas",
  "Aktiivinen": "Aktyvus",
  "Klo": "Val",
  "klo": "val",
  "Ilmoittautuminen päättyy": "Registracija baigiasi",
  "Ilmoittautumiset": "Registracijos",
  "#": "#",
  "Henkilö": "Asmuo",
  "Ilmoitautumisaika": "Registracijos laikas",
  "Kommentti": "Komentaras",
  "Tapahtumat": "Renginiai",
  "Julkaise ryhmään": "Paskelbti grupei",
  "Tapahtuman alkuaika": "Renginio pradžios laikas",
  "Tapahtuman päättymisaika": "Renginio pabaigos laikas",
  "Ilmoittautuminen": "Registracija",
  "Kommentti ilmoittautumisen yhteydessä": "Komentaras prie registracijos",
  "Tapahtuma julkaistaan heti": "Renginys paskelbiamas iš karto",
  "Tapahtuma tallennetaan luonnoksena": "Renginys išsaugojamas kaip projektas",
  "Ryhmä on pakollinen": "Grupė yra privaloma",
  "Otsikko ja teksti on pakollinen": "Antraštė ir tekstas yra privalomi",
  "Alkuaika on pakollinen": "Pradžios laikas yra privalomas",
  "Tarkista päättymisaika": "Patikrinkite pabaigos laiką",
  "Tarkista ilmoittautumisen päättymisaika": "Patikrinkite registracijos pabaigos laiką",
  "Otsikko tai teksti puuttuu": "Trūksta antraštės arba teksto",
  "Uusi tapahtuma": "Naujas renginys",
  "Aika": "Laikas",
  "Ryhmä": "Grupė",
  "Kysymykset & vastaukset": "Klausimai ir atsakymai",
  "Kysymys": "Klausimas",
  "Uusi kysymys": "Naujas klausimas",
  "Saapunut": "Atvykęs",
  "päivää sitten": "dienų anksčiau",
  "Käsittelyssä": "Apdorojamas",
  "Otettu käsittelyyn": "Priimtas apdoroti",
  "Valmis": "Baigta",
  "Palaute": "Atsiliepimas",
  "Käyttäjä toivoo vastausta": "Vartotojas tikisi atsakymo",
  "Käyttäjä ei toivo vastausta": "Vartotojas nenori atsakymo",
  "Käsittely": "Tvarkymas",
  "Ota käsittelyyn": "Priimti apdoroti",
  "Sisäinen lisätieto": "Vidinė papildoma informacija",
  "Sisäinen lisätieto ei näy palautteen lähettäjälle": "Vidinė papildoma informacija nematoma atsiliepimo siuntėjui",
  "Kuittaa käsitellyksi": "Pažymėti kaip apdorotą",
  "Palautekanava": "Atsiliepimų kanalas",
  "SUODATA": "FILTRUOTI",
  "Saapuneet": "Gauti",
  "Käsittely kesken": "Apdorojimas vyksta",
  "Valmiit": "Paruošta",
  "Saapunut tänään": "Atvyko šiandien",
  "Lisää kuva klikkaamalla tai raahaamalla kuva tähän": "Pridėkite vaizdą spustelėdami arba vilkdami vaizdą čia",
  "Julkaisuaika": "Skelbimo laikas",
  "Liitteet": "Priedai",
  "Lisää uusi liitetiedosto": "Pridėti naują pridedamą failą",
  "Voit lisätä sivulle liitteitä tallennuksen jälkeen": "Galite pridėti priedų į puslapį po išsaugojimo",
  "Video": "Vaizdo įrašas",
  "Lisää uutiseen video": "Pridėti vaizdo įrašą į naujieną",
  "Kysely": "Apklausa",
  "Lisää julkaisuun kysymys": "Pridėti klausimą į skelbimą",
  "Kyselyyn on vastattu eikä kysymyksiä voi enää muokata": "Apklausai atsakyta, klausimų daugiau keisti nebegalima",
  "Kysymykset": "Klausimai",
  "Uusi monivalintakysymys": "Naujas daugybinio pasirinkimo klausimas",
  "Uusi avoin kysymys": "Naujas atviras klausimas",
  "Kirjoita kysymys": "Įrašykite klausimą",
  "Lisää vastausvaihtoehto": "Pridėti atsakymo parinktį",
  "Kirjoita vastausvaihtoehto": "Įrašykite atsakymo parinktį",
  "Uutinen julkaistaan julkaisaikana": "Naujiena paskelbiama paskelbimo laiku",
  "Uutinen tallennetaan luonnoksena": "Naujiena išsaugojama kaip juodraštis",
  "Uutiset": "Naujienos",
  "Uusi uutinen": "Nauja naujiena",
  "Näytä vastaukset": "Rodyti atsakymus",
  "Julkaisupäivä": "Paskelbimo data",
  "Meidän yritys": "Mūsų įmonė",
  "Valitse kuva": "Pasirinkite vaizdą",
  "Lisää sivulle video": "Pridėti vaizdo įrašą puslapyje",
  "Vimeo videon id": "Vimeo vaizdo įrašo id",
  "Sivu julkaistaan heti": "Puslapis bus paskelbtas iškart",
  "Sivu tallennetaan luonnoksena": "Puslapis išsaugomas kaip juodraštis",
  "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomuotoja ovat jpeg sekä png.": "Failo formatas palaikomas. Palaikomi formatai yra jpeg ir png.",
  "Uusi sivu": "Naujas puslapis",
  "Lisää alasivu": "Pridėti palaidinį puslapį",
  "Yhteenveto": "Santrauka",
  "Vastaukset": "Atsakymai",
  "Vastausaika": "Atsakymo laikas",
  "Otsikko ja kuvaus on pakollinen": "Antraštė ir aprašymas yra privalomi",
  "Päivämäärä on pakollinen": "Data yra privaloma",
  "Kyselyssä ei ole yhtään kysymystä": "Apklausoje nėra nė vieno klausimo",
  "Tarkista kysymykset": "Patikrinkite klausimus",
  "Otsikko tai kuvaus puuttuu": "Trūksta antraštės arba aprašo",
  "Haluatko varmasti poistaaa kyselyn ja kaikki sen vastaukset?": "Ar tikrai norite ištrinti apklausą ir visus jos atsakymus?",
  "Uusi kysely": "Nauja apklausa",
  "Tiedosto": "Failas",
  "Linkki": "Nuoroda",
  "Valitse uusi tiedosto": "Pasirinkite naują failą",
  "Tämä tieto on pakollinen": "Ši informacija yra privaloma",
  "Max 500 merkkiä": "Maks 500 simbolių",
  "Tiedosto julkaistaan heti": "Failas paskelbiamas iš karto",
  "Tiedosto tallennetaan luonnoksena": "Failas išsaugomas kaip juodraštis",
  "Tiedosto puuttuu": "Trūksta failo",
  "Linkki puuttuu": "Trūksta nuorodos",
  "Tiedostot": "Failai",
  "Uusi tiedosto": "Naujas failas",
  "Avaa": "Atidaryti",
  "Tyyppi": "Tipas",
  "Asetukset": "Nustatymai",
  "Palautteiden käsittelykäytäntö": "Atsiliepimų tvarkymo politika",
  "Käyttäjät": "Naudotojai",
  "Etunimi": "Vardas",
  "Sukunimi": "Pavardė",
  "Puhelin": "Telefonas",
  "Sähköposti": "El. paštas",
  "Työtehtävä": "Darbo užduotis",
  "Näytä sähköposti kaikille": "Rodyti el. paštą visiems",
  "Näytä puhelinnumero kaikille": "Rodyti telefono numerį visiems",
  "Ryhmät": "Grupės",
  "Käyttäjä on yrityksen pääkäyttäjä, jolla on oikeudet julkaista kaikkiin ryhmiin": "Naudotojas yra įmonės pagrindinis naudotojas, turintis teisę skelbti visose grupėse",
  "Ryhmän ylläpitäjä": "Grupės administratorius",
  "Suodata": "Filtruoti",
  "Uusi käyttäjä": "Naujas naudotojas",
  "Näytä ryhmän ylläpitäjät": "Rodyti grupės administratorius",
  "Kaikki käyttäjät": "Visi naudotojai",
  "Yrityksen pääkäyttäjät": "Įmonės pagrindiniai naudotojai",
  "Näytä kuponki": "Rodyti kuponą",
  "Sulje": "Užverti",
  "Kirjoita viestisi": "Įrašykite savo žinutę",
  "Aloita keskustelu": "Pradėti pokalbį",
  "Yksityiset keskustelut": "Privatūs pokalbiai",
  "Ei kanavia": "Nėra kanalų",
  "Ryhmäkeskustelut": "Grupiniai pokalbiai",
  "Keskustelut": "Pokalbiai",
  "Viesti poistettu": "Žinutė pašalinta",
  "Poista viesti": "Trinti žinutę",
  "Olet ilmoittautunut tapahtumaan": "Jūs užsiregistravote į renginį",
  "Peru ilmoittautuminen": "Atšaukti registraciją",
  "Et ole ilmoittautunut tapahtumaan": "Jūs neužsiregistravote renginyje",
  "Ilmoittaudu mukaan": "Registruokitės dalyvauti",
  "Jätä palaute tai kysymys": "Palikite atsiliepimą ar klausimą",
  "Kiitos, viesti lähetetty": "Ačiū, žinutė išsiųsta",
  "Kirjoita palaute tai kysymys": "Rašykite atsiliepimą arba klausimą",
  "Haluan henkilökohtaisen vastauksen": "Noriu asmeninio atsakymo",
  "Anna sähköposti tai puhelinnumero": "Nurodykite el. paštą arba telefono numerį",
  "Miten palautteet käsitellään?": "Kaip tvarkomi atsiliepimai?",
  "Anna sähköpostiosoite tai puhelinnumero": "Pateikite el. pašto adresą arba telefono numerį",
  "Tervetuloa Piiriin": "Sveiki atvykę į Piirą",
  "Käyttäjätunnus tai puhelinnumero": "Naudotojo vardas arba telefono numeris",
  "Jatka": "Tęsti",
  "Salasana": "Slaptažodis",
  "Kirjaudu sisään": "Prisijunkite",
  "Pin koodi": "Pin kodas",
  "Pin koodin saapumisessa voi kestää hetken.": "Pin kodas gali užtrukti, kol atvyks.",
  "Kirjautuminen epäonnistui": "Prisijungti nepavyko",
  "Kirjautuminen epäonnistui, tarkista pin koodi": "Prisijungimas nepavyko, patikrinkite pin kodą",
  "Kirjaudutaan ulos...": "Atsijungiama...",
  "Uusimmat": "Nauji",
  "Meillä töissä": "Pas mus darbe",
  "Piiri-artikkelit": "Piiri straipsniai",
  "Omat tiedot & asetukset": "Mano duomenys ir nustatymai",
  "Tietoa Piiri-sovelluksesta": "Informacija apie Piiri programą",
  "Mikä on Piiri Kit?": "Kas yra Piiri Kit?",
  "Tietosuojaseloste": "Privatumo politika",
  "Töissä": "Darbe",
  "Poissa töistä": "Nėra darbe",
  "Anna avainsana kaikilla kielillä.": "Įveskite raktinį žodį visomis kalbomis.",
  "Avainsana": "Raktinis žodis",
  "Haluatko varmasti poistaa avainsanan?": "Ar tikrai norite ištrinti raktinį žodį?",
  "Muokkaa avainsanaa": "Redaguoti raktinį žodį",
  "Luo uusi avainsana": "Sukurti naują raktinį žodį",
  "Avainsanat": "Raktiniai žodžiai",
  "Hae avainsanoja tai lisää uusi": "Ieškoti raktinių žodžių arba pridėti naują",
  "Paina Enter luodaksesi uuden avainsanan": "Paspauskite Enter, kad sukurtumėte naują raktinį žodį",
  "Avainsanojen hallinta": "Raktinių žodžių valdymas",
  "Uudistamme kyselyjä. Pääset kokeilemaan uutta kyselytyökalua": "Atnaujiname apklausas. Galite išbandyti naują apklausų įrankį",
  "tästä": "čia",
  "Kyselyn vastaukset": "Apklausos atsakymai",
  "Viimeisin vastaus": "Paskutinis atsakymas",
  "Näytetään": "Rodoma",
  "Kyselyä ei löytynyt": "Apklausa nerasta",
  "Saat PIN-koodin tekstiviestillä mikäli puhelinnumerosi on järjestelmässämme. Syötä se alle.": "Jei jūsų telefono numeris yra mūsų sistemoje, gausite PIN kodą per SMS. Įveskite jį žemiau.",
  "Jos et saanut PIN-koodia, tarkista että syötit puhelinnumerosi oikein.": "Jei negavote PIN kodo, patikrinkite, ar teisingai įvedėte savo telefono numerį.",
  "Kirjoita hakusana": "Įveskite paieškos žodį",
  "Hakusanan tulee olla vähintään 3 merkkiä pitkä": "Paieškos žodis turi būti bent 3 simbolių ilgio"
}
